import useWidth from '@components/Hooks/useWidth';
import { WORKSPACE_PADDING, WORKSPACE_PADDING_MOBILE } from '@components/v2/constants';

export const useWorkspacePadding = () => {
  const { mobileWidth } = useWidth();

  return {
    padding: mobileWidth ? WORKSPACE_PADDING_MOBILE : WORKSPACE_PADDING,
    isMobile: mobileWidth,
  };
};
